import { IItemFilterHandler } from '../../../controls/filteredItemSetControl';
import { KeyFacet, stringPart } from '../../KeyFacet';
import { IItemCache } from '../../IItemCacheObserver';
import { fileNameFacet } from '../../../facets/ItemFacets';

const itemExtensionFilterHandlerKeyFacet = new KeyFacet<{
  extension: string;
}>('itemSetExtensionFilterHandler', {
  extension: stringPart({ shouldNormalizeCasing: true })
});

/**
 * Determines the file extension used by a given filter, if the filter is an item extension filter.
 */
export function getExtensionFromFilterHandler(filterHandler: IItemFilterHandler): string | undefined {
  if (itemExtensionFilterHandlerKeyFacet.matches(filterHandler.key)) {
    const {
      extension
    } = itemExtensionFilterHandlerKeyFacet.deserialize(filterHandler.key);

    return extension;
  }

  return undefined;
}

/**
 * Creates a new filter for items by file extension.
 * All filters handler instances created for a specific file extension will have the same `.key` values.
 * To determine which extension is screened by a filter, use `getExtensionFromFilterHandler`.
 *
 * @example
 *  const docxFilterHandler = getItemExtensionFilterHandler('.docx');
 *  const extension = getExtensionFromFilterHandler(docxFilterHandler); // '.DOCX'
 */
export function getItemExtensionFilterHandler(extension: string): IItemFilterHandler {
  const key = itemExtensionFilterHandlerKeyFacet.serialize({
    extension: extension
  });

  return {
    key: key,
    filter: (itemCache: IItemCache, props: {
      itemKey: string;
    }): boolean => {
      const fileName = itemCache.demandItemFacet(fileNameFacet, props.itemKey);

      return !!fileName && fileName.extension === extension;
    }
  };
}
